package org.hs_soft.runmynesto.domain.model.home.closing_reports

import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

enum class ReportsTableHeadersEnum(
    val title:String,
    val width:CSSSizeValue<CSSUnit.px>,
    val arrangement: Arrangement.Horizontal,
){
    DATE(
        title =LanguageManager.getCurrentStrings().date ,
        width =Dimen.reportsTableDateWidth,
        arrangement = Arrangement.Start
    ),
    TIME(
        title =LanguageManager.getCurrentStrings().time ,
        width =Dimen.reportsTableTimeWidth,
        arrangement = Arrangement.Start
    ),
    NUMBER_DOT(
        title =LanguageManager.getCurrentStrings().numberDot ,
        width =Dimen.reportsTableNumberWidth,
        arrangement = Arrangement.End
    ),
    DEVICES(
        title =LanguageManager.getCurrentStrings().devices ,
        width =Dimen.reportsTableDeviceWidth,
        arrangement = Arrangement.Start
    ),
    SALES_VOLUME(
        title =LanguageManager.getCurrentStrings().salesVolume ,
        width =Dimen.reportsTableSalesVolumeWidth,
        arrangement = Arrangement.End
    )


}